

export const stackCardHeight = {
    navBar: 64,
    header: 72,
    search: 72,
    help: 180,
    actions: 54,
    bread: 24,
}